import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=d322b2b8&scoped=true"
import script from "./Question.vue?vue&type=script&lang=ts"
export * from "./Question.vue?vue&type=script&lang=ts"
import style0 from "./Question.vue?vue&type=style&index=0&id=d322b2b8&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d322b2b8",
  null
  
)

export default component.exports